import { useEffect, useState } from 'react'

/** iPad 类触控平板：粗指针 + 中等宽度（含 Mini 竖屏 ~744），避免桌面宽屏误入密看 */
export const SURVEILLANCE_TABLET_DENSITY_MQ =
  '(pointer: coarse) and (min-width: 700px) and (max-width: 1366px)'

export function getSurveillanceTabletDensityMatches () {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false
  }
  return window.matchMedia(SURVEILLANCE_TABLET_DENSITY_MQ).matches
}

export function useSurveillanceTabletDensity () {
  const [isTabletDensity, setIsTabletDensity] = useState(getSurveillanceTabletDensityMatches)

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
      return undefined
    }
    const mql = window.matchMedia(SURVEILLANCE_TABLET_DENSITY_MQ)
    const onChange = () => setIsTabletDensity(mql.matches)
    onChange()
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', onChange)
      return () => mql.removeEventListener('change', onChange)
    }
    mql.addListener(onChange)
    return () => mql.removeListener(onChange)
  }, [])

  return isTabletDensity
}
